import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useToast } from '@/hooks/use-toast';
import { XCircle } from 'lucide-react';

const PaymentCancel = () => {
  const navigate = useNavigate();
  const { toast } = useToast();

  useEffect(() => {
    toast({
      title: "Payment Cancelled",
      description: "Your payment was cancelled. Please try again.",
      variant: "destructive",
    });

    // Redirect after 3 seconds
    const timer = setTimeout(() => {
      navigate('/pricing');
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-gray-900 to-gray-950">
      <div className="text-center space-y-4">
        <XCircle className="h-16 w-16 text-red-500 mx-auto" />
        <h1 className="text-2xl font-bold text-white">Payment Cancelled</h1>
        <p className="text-gray-400">Your payment was not completed.</p>
        <p className="text-gray-400">Redirecting you back to pricing...</p>
      </div>
    </div>
  );
};

export default PaymentCancel; 